// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.
export const operatingSystems = ["macos", "windows", "linux"] as const;
export type OperatingSystem = (typeof operatingSystems)[number];

export function detectOperatingSystem(
  userAgent: string,
  platform = "",
): OperatingSystem {
  const value = `${platform} ${userAgent}`.toLowerCase();
  if (
    value.includes("macintosh") ||
    value.includes("mac os") ||
    value.includes("macintel")
  )
    return "macos";
  if (value.includes("windows") || value.includes("win32")) return "windows";
  return "linux";
}
